<template>
  <div style="text-align: center;">
    <div class="background">
      <img src="../../../static/images/login/login_background.jpg" class="backgroud">
    </div>
    <div>
      <a href="/hy-mic-sy/home">
        <img src="../../../static/images/logo/logo-s.png" class="logo">
      </a>

    </div>
    <div class="allStyle" style="height: 1px;">
      <el-card class="box-card">
        <div class="text item">
          <div class="login_style">
            <div class="choose-box" style="line-height: 40px">
              <el-radio class="mall-login" v-model="entrance" label="1">终端入口</el-radio>
              <el-radio class="back-login" v-model="entrance" label="2" style="margin-right:1px;margin-left: 50px">
                后台管理
              </el-radio>
            </div>
            <p
              style="color: #000;font-size: 14px;margin-top: 25px;margin-bottom: 25px;border-top: 1px solid #DCDDDE;padding-top: 20px">
              <b style="font-size: 14px">账号登录</b>
            </p>
            <el-input
              name="username"
              id="id_username"
              prefix-icon="el-icon-s-custom"
              style="width: 300px;"
              class="input_space"
              v-model="phone"
              placeholder="请输入用户名">
            </el-input>

            <el-input
              name="password"
              style="width: 300px;"
              id="id_password"
              prefix-icon="el-icon-lock"
              class="input_space"
              placeholder="请输入密码"
              v-model="password"
              show-password>
            </el-input>

            <el-checkbox
              v-model="checked"
              style="margin-left: 40px;float: left;
              margin-bottom: 25px;">记住密码
            </el-checkbox>
            <div style="clear: both"></div>
            <el-button
              :loading="loginLoading"
              @click="login"
              type="primary"
              style="width: 250px; text-align: center;
              border-radius: 50px; background-color:#0C78D3;
              font-size: 18px; letter-spacing:2px;
              margin-top: 15px;
              display: inline-block;"
            >登 录
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
    <div class="website-info">
      <div class="copyright-info">
        <p style="line-height: 25px;padding-top: 25px">
          版权所有©清远市嘉兴医药有限公司 |
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/86a6e65c59d2cd7b9481b4cb9b2b71d.png"
             target="_blank">
            互联网药品信息服务资格证书编号(粤)-经营性-2022-0473
          </a> <br>
          ICP主体备案号：
          <a href="http://beian.miit.gov.cn" target="_blank">
            粤ICP备2022140739号
          </a><br>
          <a href="https://liangyituan.oss-cn-shenzhen.aliyuncs.com/clinic/0ff0aa0b2af166f931fc51d1a46c48e.jpg"
             target="_blank">营业执照副本</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {UserService} from '@/service/UserService'

export default {
  data() {
    return {
      entrance: '1',
      phone: '',
      password: '',
      checked: false,
      loginLoading: false
    }
  },
  mounted() {
    this.phone = localStorage.getItem('phone')
    this.password = localStorage.getItem('pwd')
    if (localStorage.getItem('checked') == 1) {
      this.checked = true
    }

  },
  methods: {
    login() {
      this.loginLoading = true;
      const data = {
        phone: this.phone,
        pwd: this.password
      }
      const userService = new UserService(this.$axios);
      if (this.entrance == '1') {
        userService.loadTerminal(data).then(res => {
          this.DealLogin(res, this.entrance, data)
        }).finally(_ => {
          this.loginLoading = false;
        })
      }
      if (this.entrance == '2') {
        userService.loadShop(data).then(res => {
          this.DealLogin(res, this.entrance, data)
        }).finally(_ => {
          this.loginLoading = false;
        })
      }
    },
    dealBusinessLogin(res) {
      const {content: {type}} = res
      console.log('登录商业入口')
      if (type !== 0) {
        this.$router.push({
          path: 'index'
        })
      } else {
        this.LoginMsg = '请从终端入口登录'
        this.$bvToast.show('toast-msg')
      }
    },
    DealLogin(res, way, data) {
      if (res.code === '0' && res.code !== null) {
        if (this.isRemember) {
          this.setCookie(data.phone, data.pwd, 7)
        } else {
          this.setCookie('', '', -1)// 清空
        }
        console.log('成功:' + way)
        // 登录成功后的操作
        if (way == '1') {
          this.rememberUser(way)
          window.location.href = 'https://www.qyjiaxing.com/index.htm'
        }
        if (way == '2') {
          this.rememberUser(way)
          window.location.href = 'https://www.qyjiaxing.com/hy-mic-syms/index'
        }
      } else {
        // 登录失败后的操作
        this.LoginMsg = res.msg
        this.$message.error(res.msg)
        this.$bvToast.show('toast-msg')
        // this.makeToast()
      }
    },
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
      window.document.cookie = 'userName' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
    },
    rememberUser(entrance) {
      if (this.checked) {
        localStorage.setItem("phone", this.phone)
        localStorage.setItem("pwd", this.password)
        localStorage.setItem("checked", '1')
      } else {
        localStorage.removeItem("phone")
        localStorage.removeItem("pwd")
        localStorage.setItem("checked", '0')
      }
    }
  }
}
</script>
<style scoped>
.website-info {
  height: 112px;
  text-align: center;
  line-height: 112px;
}

.choose-box {
  height: 35px;
}

.logo {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 30px;
  left: 150px;
}

.backgroud {
  text-align: center;
  width: 1920px;
  height: 820px;
}

.input_space {
  text-align: center;
  margin-bottom: 15px;
  width: 250px;
}

.box-card {
  position: absolute;
  border-radius: 10px;
  top: 200px;
  right: 260px;
  width: 420px;
  height: 475px;
  background-color: #fff !important
}

</style>
